// extracted by mini-css-extract-plugin
export default {"container":"cartItem_container__b9D2q","imageContainer":"cartItem_imageContainer__rNAVg","info":"cartItem_info__ktDov","delete":"cartItem_delete__19RWv"};